import { useTranslation } from 'react-i18next'

import { MapPin } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const AddTrackingNumberTitle = () => {
  const { t } = useTranslation()

  return (
    <Styles.ActionTitleContainer>
      <MapPin size={16} />
      <Text type="bodyMRegular">{t('Añadir número de seguimiento')}</Text>
    </Styles.ActionTitleContainer>
  )
}

export default AddTrackingNumberTitle
